import log from 'salvo-lite/log'
import ReadMore from '../components/ReadMore'

class Results {
    constructor (components) {
        log.debug(this.constructor.name, 'Constructing', components)
        this._components = components
        this._sliderBlocks = document.querySelectorAll('.result-category')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiated', this)
        if (this._sliderBlocks.length > 0) {
            this.triggerSliders()
        }
    }

    triggerSliders () {
        this.sliders = {}
        for (var i = 0; i < this._sliderBlocks.length; i++) {
            let idx = 'resultsSlider-' + i
            this.sliders[idx] = this._components.getComponentsById(idx)

            this.sliders[idx]._elem.addEventListener('initiated', () => {
                for (let slide of this.sliders[idx]._slides) {
                    let readMore = slide.querySelector('[data-read-more]')
                    slide.readMore = new ReadMore(window.__theme, readMore)
                    slide.readMore.init()
                }
            })
            this.sliders[idx].init()
        }
    }
}

export default Results



// WEBPACK FOOTER //
// ./src/scripts/pages/Results.js